@use '../common/vars.scss' as vars;
@use '../common/colors.scss' as colors;

.tripExpired {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

:global(.header-txt).header {
  margin-top: 1.25em;
  margin-bottom: 0.75em;
  text-align: center;
  line-height: 33px;

  @media screen and (max-width: vars.$mobile) {
    font-size: 1.5em;
  }
}

.text {
  color: colors.$body-text;

  & > * {
    margin-bottom: 10px;
  }
}

// Flexpay
:global(.flexpay) {
  :global(.trip-expired-header) {
    text-align: left;
  }
}
